import togetherIcon1 from '../assets/images/services/together-icon.svg'
import togetherIcon2 from '../assets/images/services/together-icon-2.svg'
import togetherIcon3 from '../assets/images/services/together-icon-3.svg'
import workTogetherImage from '../assets/images/services/team-section.png'

/**
 * Dot colors for {@link ServiceOneTeam} (order: step 1 → 4).
 */
export const ONE_TEAM_DOT_COLORS = ['#ffffff', '#FFA600', '#FF6600', '#CC0000']

/** Default “One Team” copy for Application Development & Modernization service pages. */
export const SERVICE_ONE_TEAM_APPLICATION_EN = {
  titleBefore: 'We work with you as ',
  titleHighlight: 'One Team.',
  imageAlt: 'Team collaborating in the office',
  steps: [
    {
      id: 'discovery',
      title: 'Discovery',
      body:
        'We dive deep to understand your business goals and your audience’s needs.',
      dotCount: 1,
    },
    {
      id: 'design',
      title: 'Design',
      body: 'We design and test possible solutions for the challenge at hand.',
      dotCount: 2,
    },
    {
      id: 'development',
      title: 'Development',
      body:
        'We create a fully functional and engaging digital product that suits your company’s needs.',
      dotCount: 3,
    },
    {
      id: 'support',
      title: 'Support',
      body: 'You can count on our support even after the project is finished.',
      dotCount: 4,
    },
  ],
  workTogether: {
    titleBefore: 'Flexible ways to ',
    titleHighlight: 'Work Together.',
    imageAlt: 'Team collaborating in a modern office',
    imageSrc: workTogetherImage,
    columns: [
      {
        id: 'staff-augmentation',
        title: 'Staff Augmentation',
        body:
          'We integrate into your operations with highly skilled talent, including project managers, developers, engineers, designers, and specialists in data, AI, cloud, and cybersecurity.',
        icon: togetherIcon1,
      },
      {
        id: 'dedicated-teams',
        title: 'Dedicated Teams',
        body:
          'Your dedicated dream team awaits. We handpick specialists who understand your culture and values to be your project’s champions.',
        icon: togetherIcon2,
      },
      {
        id: 'managed-delivery',
        title: 'Managed Delivery',
        body:
          'Entrust your projects to us. We will implement your plans on a turn-key basis and relieve you of the day-to-day management burden.',
        icon: togetherIcon3,
      },
    ],
  },
}

export const SERVICE_ONE_TEAM_APPLICATION_PT = {
  titleBefore: 'Trabalhamos consigo como ',
  titleHighlight: 'Uma equipa.',
  imageAlt: 'Equipa a colaborar no escritório',
  steps: [
    {
      id: 'discovery',
      title: 'Descoberta',
      body:
        'Aprofundamos o conhecimento dos seus objetivos de negócio e das necessidades do seu público.',
      dotCount: 1,
    },
    {
      id: 'design',
      title: 'Design',
      body:
        'Desenhamos e testamos soluções possíveis para o desafio em questão.',
      dotCount: 2,
    },
    {
      id: 'development',
      title: 'Desenvolvimento',
      body:
        'Criamos um produto digital completo e envolvente, alinhado com as necessidades da sua empresa.',
      dotCount: 3,
    },
    {
      id: 'support',
      title: 'Suporte',
      body:
        'Pode contar com o nosso suporte mesmo depois de o projeto estar concluído.',
      dotCount: 4,
    },
  ],
  workTogether: {
    titleBefore: 'Formas flexíveis de ',
    titleHighlight: 'Trabalhar em conjunto.',
    imageAlt: 'Equipa a colaborar num escritório moderno',
    imageSrc: workTogetherImage,
    columns: [
      {
        id: 'staff-augmentation',
        title: 'Reforço de equipa',
        body:
          'Integramo-nos na sua operação com talento altamente qualificado, incluindo gestores de projeto, developers, engenheiros, designers, especialistas em dados, IA, cloud e cibersegurança.',
        icon: togetherIcon1,
      },
      {
        id: 'dedicated-teams',
        title: 'Equipas dedicadas',
        body:
          'A sua equipa de sonho, dedicada ao projeto. Selecionamos especialistas alinhados com a sua cultura e valores para liderar o trabalho.',
        icon: togetherIcon2,
      },
      {
        id: 'managed-delivery',
        title: 'Entrega gerida',
        body:
          'Confie-nos os seus projetos. Implementamos o plano de forma chave na mão e retiramos a carga da gestão do dia a dia.',
        icon: togetherIcon3,
      },
    ],
  },
}
